export enum QueryKeyEnum {
  ACTIVE_AREA_OF_INTERESTS = 'ACTIVE_AREA_OF_INTERESTS',
  ADMIN_CANDIDATE_PROFILE = 'ADMIN_CANDIDATE_PROFILE',
  ADMIN_DASHBOARD = 'ADMIN_DASHBOARD',
  ANSWER_QUESTION = 'ANSWER_QUESTION',
  ASSESS_USER_SKILLS = 'ASSESS_USER_SKILLS',
  CHECK_INTERNAL_MODE = 'CHECK_INTERNAL_MODE',
  DICTIONARIES = 'DICTIONARIES',
  GENERATE_TOKEN = 'GENERATE_TOKEN',
  GET_CURRENT_USER = 'GET_CURRENT_USER',
  GET_QUIZ_DEFINITION = 'GET_QUIZ_DEFINITION',
  GET_QUIZ_IDENTIFIERS = 'GET_QUIZ_IDENTIFIERS',
  GET_QUIZ_QUESTION = 'GET_QUIZ_QUESTION',
  GET_QUIZ_STATE = 'GET_QUIZ_STATE',
  GET_SKILLS_ASSESSMENT = 'GET_SKILLS_ASSESSMENT',
  GET_USER_PERSONAL_DATA = 'GET_USER_PERSONAL_DATA',
  GET_USER_QUIZZES = 'GET_USER_QUIZZES',
  GET_USER_SKILLS_ASSESSMENT = 'GET_USER_SKILLS_ASSESSMENT',
  INITIALIZE_QUIZ = 'INITIALIZE_QUIZ',
  LOGIN = 'LOGIN',
  PROCESS = 'PROCESS',
  PROCESS_INFO = 'PROCESS_INFO',
}
